import { render, staticRenderFns } from "./CadastroAgendas.vue?vue&type=template&id=c430e93e&"
import script from "./CadastroAgendas.vue?vue&type=script&lang=js&"
export * from "./CadastroAgendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports